<template>
	<reqsType :baseUrlpath="baseUrlpath" :reqType="reqType"></reqsType>
</template>

<script>
	import {
		queryUrl,
		doPost
	} from '@/api/index';
	import {
		Toast
	} from 'mint-ui';
	import reqsType from '@/components/reqsType.vue'
	export default {
		name: '闲置市场',
		metaInfo: {
			title: '中东华人宝-闲置市场',
			meta: [{
					name: 'keyWords',
					content: '闲置市场'
				},
				{
					name: 'description',
					content: '电子产品/摄影,奢侈品,家居,生活百货,服装鞋帽,办公用品,卡券门票,会员,箱包,宠物,体育用品,免费赠品'
				}
			]
		},
		components: {
			reqsType
		},
		data() {
			return {
				baseUrlpath: '',
				reqType: '4'
			}
		},
		created() {
			this.baseUrlpath = this.baseUrl;
			var inchina = localStorage.getItem('inChina');
			if(inchina == '1'){
				this.baseUrlpath = this.baseUrlCN;
			}
		},
		methods: {}
	}
</script>

<style>
</style>